<div class="rounded-lg bg-white p-6 shadow-sm">
  <div class="flex items-center justify-between border-b border-gray-100 pb-4">
    <h2 class="text-primary text-base font-semibold" i18n="@@userInformation">User Information</h2>

    <div class="relative">
      <button
        (click)="toggleDropdown($event)"
        class="hover-text-primary inline-flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100">
        <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 16 16">
          <path
            d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
        </svg>
      </button>

      @if (showDropdown()) {
        <div
          class="animate-in fade-in zoom-in absolute top-full z-50 mt-1 min-w-[160px] rounded-lg border border-gray-200 bg-white p-1 shadow-2xl duration-100 ltr:right-0 rtl:left-0">
          <button
            i18n="@@action.editUser"
            class="flex w-full items-center px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-100">
            Edit User
          </button>
          <button
            i18n="@@action.deactivateUser"
            class="flex w-full items-center px-3 py-2 text-xs font-semibold text-gray-700 hover:bg-gray-100">
            Deactivate User
          </button>
          <button
            i18n="@@action.deleteUser"
            class="flex w-full items-center px-3 py-2 text-xs font-semibold text-red-500 hover:bg-red-50">
            Delete User
          </button>
        </div>
      }
    </div>
  </div>

  <div class="mt-6 grid grid-cols-2 gap-x-12 gap-y-6">
    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs text-gray-400" i18n="@@fullName">Full Name</span>
      @if (fullName) {
        <span class="text-sm font-medium break-words text-gray-800">{{ fullName }}</span>
      } @else {
        <span class="text-sm text-gray-400 italic" i18n="@@notAssigned">Not assigned yet</span>
      }
    </div>

    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs text-gray-400" i18n="@@mobile">Mobile</span>
      @if (data().mobileNumber) {
        <span class="text-sm font-medium text-gray-800" dir="ltr">{{ data().mobileNumber }}</span>
      } @else {
        <span class="text-sm text-gray-400 italic" i18n="@@notAssigned">Not assigned yet</span>
      }
    </div>

    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs text-gray-400" i18n="@@emailAddress">Email Address</span>
      @if (data().email) {
        <span class="text-sm font-medium break-words text-gray-800">{{ data().email }}</span>
      } @else {
        <span class="text-sm text-gray-400 italic" i18n="@@notAssigned">Not assigned yet</span>
      }
    </div>

    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs text-gray-400" i18n="@@gender">Gender</span>
      @if (genderLabel) {
        <span class="text-sm font-medium text-gray-800">{{ genderLabel }}</span>
      } @else {
        <span class="text-sm text-gray-400 italic" i18n="@@notAssigned">Not assigned yet</span>
      }
    </div>

    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs text-gray-400" i18n="@@defaultLanguage">Default Language</span>
      <span class="text-sm font-medium text-gray-800">{{ languageLabel }}</span>
    </div>

    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs text-gray-400" i18n="@@birthDate">Birth Date</span>
      @if (data().birthDate) {
        <span class="text-sm font-medium text-gray-800">{{ data().birthDate | date: "dd/MM/yyyy" }}</span>
      } @else {
        <span class="text-sm text-gray-400 italic" i18n="@@notAssigned">Not assigned yet</span>
      }
    </div>

    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs text-gray-400" i18n="@@role">Role</span>
      <div class="group/roles relative flex flex-wrap items-center gap-1">
        @if (data().roles && data().roles.length > 0) {
          <span
            class="inline-flex w-36 items-center justify-center rounded-md border border-blue-100 bg-blue-50 px-2 py-0.5 text-center text-[10px] font-bold whitespace-nowrap text-blue-700">
            {{ getRoleTitle(data().roles[0]) }}
          </span>
          @if (data().roles.length > 1) {
            <span
              class="inline-flex min-w-[25px] items-center justify-center rounded-md border border-gray-200 bg-gray-100 px-1.5 py-0.5 text-[10px] font-bold text-gray-600">
              +{{ data().roles.length - 1 }}
            </span>
            <div
              class="absolute bottom-full z-[110] mb-2 hidden min-w-[150px] flex-col gap-1 rounded-lg border border-gray-200 bg-white p-2 shadow-xl group-hover/roles:flex">
              @for (role of data().roles; track role.id) {
                <span class="border-b py-0.5 text-[11px] font-semibold text-gray-700 last:border-0">
                  • {{ getRoleTitle(role) }}
                </span>
              }
            </div>
          }
        } @else {
          <span class="text-sm text-gray-400 italic" i18n="@@notAssigned">Not assigned yet</span>
        }
      </div>
    </div>

    <div class="flex min-w-0 flex-col gap-1">
      <span class="text-xs text-gray-400" i18n="@@memberSince">Member Since</span>
      @if (data().createdOn) {
        <span class="text-sm font-medium text-gray-800">{{ data().createdOn | date }}</span>
      } @else {
        <span class="text-sm text-gray-400 italic" i18n="@@notAssigned">Not assigned yet</span>
      }
    </div>
  </div>
</div>
